import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { ViewChoiceContext } from '../../__state/ViewChoice';
import __upperCase from 'lodash/upperCase';
import {
	VIEW_G_EXPORT,
	VIEW_G_COMMAND,
	VIEW_TABLE,
	VIEW_PLOTS,
	VIEW_EXPORT,
	VIEW_COMMAND,
	VIEW_DASHBOARD,
	VIEW_NOTIFICATIONS,
	VIEW_SIMULATION,
} from '../../utils/constants';

import './ViewChooser.scss';
import { useLocation, useNavigate } from 'react-router-dom';

const ViewChooser = ({ type, views }) => {
	const navigate = useNavigate();
	const location = useLocation();
	const { devicesView, entriesView, setDevicesView, setEntriesView } =
		useContext(ViewChoiceContext);
	const setView = (view) => {
		// TODO: remove entries view state in favor of query params - right
		// now, mobile uses hashes and it's not optimized
		// example: url?imei=____&view=___
		const url = `/weather-display#${view.toLowerCase()}`;
		navigate(url);

		return type === 'devices' ? setDevicesView(view) : setEntriesView(view);
	};

	const setHighlightClass = (view) => {
		if (true) {
			if (location.hash === view.toLowerCase()) {
				return 'highlight';
			}
		} else if (devicesView === view || entriesView === view) {
			return 'highlight';
		}

		return '';
	};

	return (
		<div className="view-chooser">
			{views.map((view, i) => (
				<div
					key={i}
					role="button"
					className={`view-choice ${setHighlightClass(view)}`}
					onClick={() => setView(view)}>
					{__upperCase(view)}
				</div>
			))}
		</div>
	);
};

ViewChooser.propTypes = {
	type: PropTypes.oneOf(['devices', 'entries']),
	views: PropTypes.arrayOf(
		PropTypes.oneOf([
			VIEW_G_EXPORT,
			VIEW_G_COMMAND,
			VIEW_TABLE,
			VIEW_PLOTS,
			VIEW_EXPORT,
			VIEW_COMMAND,
			VIEW_DASHBOARD,
			VIEW_NOTIFICATIONS,
			VIEW_SIMULATION,
		]),
	).isRequired,
};

export default ViewChooser;
